import React, { useCallback, useRef } from "react";
import { useDispatch } from "react-redux";
import { Card, Container, Row, Col, Button } from "react-bootstrap";
import { allRapportBi } from "../Redux/rapportReduce";
import jwt_decode from "jwt-decode";
import Select from "react-select";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

function ListeRapport({ client }) {
  document.title = "Rapport Commercial";
  const dispatch = useDispatch();
  var token = localStorage.getItem("x-access-token");
  var decoded = jwt_decode(token);
  const id = decoded.id;
  var dateToday = new Date();
  var releveDate =
    dateToday.getDate() +
    "/" +
    (dateToday.getMonth() + 1) +
    "/" +
    dateToday.getFullYear();
  var dateToday = new Date();
  var anneeLocal = localStorage.getItem("annee");
  const [alert, setAlert] = React.useState(null);
  const [loader, setLoader] = React.useState(false);

  const [typeSelect, setTypeSelect] = React.useState({
    value: "0",
    label: "MAT",
  });
  const [optionType] = React.useState([
    {
      value: "MAT",
      label: "MAT",
    },
    {
      value: "24",
      label: "24",
    },
    {
      value: "36",
      label: "36",
    },
  ]);


  // const exportBiExcel = async (data, filename) => {
  //   const workbook = new ExcelJS.Workbook();
  //   const worksheet = workbook.addWorksheet("Rapportscommercial");

  //   if (data.length > 0) {
  //     // Entêtes dynamiques à partir des clés du premier objet
  //     const headers = Object.keys(data[0]);
  //     worksheet.addRow(headers);

  //     // Lignes de données
  //     data.forEach((row) => {
  //       const rowValues = headers.map((key) => row[key]);
  //       worksheet.addRow(rowValues);
  //     });
  //   }

  //   const buffer = await workbook.xlsx.writeBuffer();
  //   const blob = new Blob([buffer], {
  //     type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //   });

  //   saveAs(blob, `${filename}.xlsx`);
  // };

  const exportBiExcel = async (data, filename) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    console.warn("No data to export");
    return;
  }

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Rapportscommercial");

  // Entêtes dynamiques à partir des clés du premier objet
  const headers = Object.keys(data[0]);
  worksheet.addRow(headers);

  // Lignes de données
  data.forEach((row) => {
    const rowValues = headers.map((key) => row[key]);
    worksheet.addRow(rowValues);
  });

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });

  saveAs(blob, `${filename}.xlsx`);
};


  const [data, setData] = React.useState([]);
  const [data1, setData1] = React.useState([]);
  const [bi, setBi] = React.useState([]);
  const [biVente, setBiVente] = React.useState([]);

  const getBI = useCallback(
    async (anneeLocal, client, typeSelect) => {
      setLoader(true)
      var prod = await dispatch(
        allRapportBi({
          id: id,
          client,
          annee: parseInt(anneeLocal), periode: typeSelect.value
        })
      );
      setLoader(false)
      var res = prod.payload.r;
      setBiVente(res);
      setLoader(false);
    },
    [dispatch, id]
  );

  // React.useEffect(() => {
  //   getBI(anneeLocal, client, typeSelect);
  //   return () => {
  //     setLoader(false);
  //     setBi([]);
  //     setBiVente([]);
  //   };
  // }, [getBI, anneeLocal, typeSelect]);

  const effectRan = useRef(false);

  React.useEffect(() => {
    if (!effectRan.current) {
      getBI(anneeLocal, client, typeSelect);
      effectRan.current = true;
    }
    return () => { };
  }, [getBI, anneeLocal, typeSelect]);

  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col md="12">
            <Card>
              <Card.Header>
                <Card.Title as="h4">
                  Rapport commercial
                </Card.Title>
              </Card.Header>
              <Card.Body>
                {loader === true ? (
                  <div class="loader-container">
                    <div class="loader"></div>
                  </div>
                ) : (
                  <Row>
                    <Col md="6">
                      <span>Mois * </span>
                      <Select
                        className="react-select primary"
                        classNamePrefix="react-select"
                        name="Type"
                        placeholder="Mois"
                        value={typeSelect}
                        onChange={(v) => {
                          setTypeSelect(v);
                        }}
                        options={optionType}
                      />
                    </Col>
                    <br all="clear"></br>
                    <br></br>
                    <br></br>
                    <hr />
                    <br></br>
                    <br></br>
                    <Col md="12" style={{ textAlign: "center" }} className="pdfExcel  ">

                      <Button
                        className="btn  btn-export p-2"
                        onClick={() => exportBiExcel(biVente, `${releveDate}rapportcommercial`)}
                      >
                        Exporter en Excel – Rapport commercial    <i className="fas fa-file-excel"></i>
                      </Button>

                    </Col>

                  </Row>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListeRapport;
